export default __webpack_public_path__ + "static/media/Category-Bundles.e8ac3c5b.jpg";